import { Pipe, PipeTransform } from '@angular/core';

import dayjs from "dayjs";
import 'dayjs/locale/es';

// import * as (no require) para que el pipe sea ESM y no dispare el bailout de CommonJS.
// Mismo estilo que el `import * as dayjs` de arriba; los subpaths van en
// allowedCommonJsDependencies (angular.json).
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);

@Pipe({
    name: 'time',
    standalone: true
})
export class TimePipe implements PipeTransform {
  transform(value: any, format = ''): string {

    if (format) return dayjs(value).locale('es').format(format);

    //@ts-ignore
    dayjs.updateLocale('es', {
      relativeTime: {
        future: 'en %s',
        past: 'Hace %s',
        s: '1 segundo',
        ss: '%d segundos',
        m: '1 minuto',
        mm: '%d minutos',
        h: '1 hora',
        hh: '%d horas',
        d: '1 día',
        dd: '%d días',
        M: '1 mes',
        MM: '%d meses',
        y: '1 año',
        yy: '%d años',
      },
    });

    //@ts-ignore
    return dayjs().locale('es').to(dayjs(value))
  }

}